export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: number;
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_Su1sa9fv58UlZj',
    priceId: 'price_1RyDp0C4cgXHZkKDivG0L6Ub',
    name: 'Resource Card',
    description: 'List your ranch equipment, tools, or supplies for sale or rent.',
    mode: 'payment',
    price: 5.00
  },
  {
    id: 'prod_Su1rWJ7KGQ4kNC',
    priceId: 'price_1RyDnmC4cgXHZkKDNj5nrBST',
    name: 'Job seeker Card',
    description: 'Keeping the lights on and helping you get visibility',
    mode: 'payment',
    price: 5.00
  }
];

export function getProductByPriceId(priceId: string): StripeProduct | undefined {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
}

export function getProductById(id: string): StripeProduct | undefined {
  return STRIPE_PRODUCTS.find(product => product.id === id);
}